import React, { Component } from 'react'
import './Section5.scss'

export default class Section5 extends Component {
    render() {
        return (
            <div className = "Section5Container">
                <h1> Ready to build your community?</h1>
                <button> Get Started For Free</button>
            </div>
        )
    }
}
